import { CONTENT } from '../Store/Actions'
import store from '../store'
import axios from 'axios'

class GEST_API {

    static PROJECT_SAVING = false;
    static IN_CONFLICT = false;
    static UPDATE_INTERVAL = null;
    static NETWORK_ERROR_COUNT = 0
    static NETWORK_ERROR_NOTIFICATION_THRESHHOLD = 4
    static REQUEST_CONTROLLER = new AbortController();

    static GET_PROJECT(projectId, lastUpdatedTimestamp) {

        let resource = `project/?projectId=${projectId}&downloadedTimestamp=${lastUpdatedTimestamp}`;
        this.CALL({ resource:resource } 
        )
        .then(response => {
            
            if(!this.PROJECT_SAVING && !response.data.isUpToDate){

                if(response.data // 👈 null and undefined check
                    && Object.keys(response.data).length === 0
                    && Object.getPrototypeOf(response.data) === Object.prototype)
                {
                    //To-do new dispatch for when it doesn't exist
                    store.dispatch({ type: CONTENT.PROJECT_CONTENT_RECIVED, payload: response.data })

                }else{ 
                    //Do not dispatch if we're not polling for changes

                    if(this.UPDATE_INTERVAL !== null){
                        
                        //Dispatch if we have schema + content available
                        //Only dispatch if the recived content is new
                        store.dispatch({ type: CONTENT.PROJECT_CONTENT_RECIVED, payload: response.data })
                        
                    }

                }
            }

            store.dispatch({ type: CONTENT.CONNECTION_ISSUES, payload: false })

        })
        .catch(error =>{
            console.log(error)
        });

    }

    static START_UPDATE_CHECKER() {
        if(!this.UPDATE_INTERVAL){
            this.UPDATE_INTERVAL = setInterval(() => {
                if(store.getState().project.projectId !== undefined){
                    this.GET_PROJECT(store.getState().project.projectId, store.getState().project.lastUpdateTimestamp)
                }
            }, 5000);
        }
    }

    static STOP_UPDATE_TRACKER() {
        if(this.UPDATE_INTERVAL){
            clearInterval(this.UPDATE_INTERVAL)
            this.UPDATE_INTERVAL = null
        }
    }

    static SAVE_PROJECT(payload, force = false) {
        return new Promise((resolve, reject) => {
            if(!this.IN_CONFLICT){
                let clonedPayload = JSON.parse(
                                                JSON.stringify(
                                                    {
                                                        project:payload,
                                                        downloadedTimestamp:payload.lastUpdateTimestamp,
                                                        forceSave:force
                                                    }
                                                )
                                            )

                this.STOP_UPDATE_TRACKER();
                let resource = `project`;
                this.PROJECT_SAVING = true;

                clonedPayload.project.lastUpdateTimestamp = new Date().getTime();
                
                this.CALL({ resource:resource, data:clonedPayload, method:'POST' })

                .then(response => {
                    this.PROJECT_SAVING = false
                    resolve({response:response.data, payload:clonedPayload});
                    this.START_UPDATE_CHECKER();
                })
                .catch(error =>{
                    this.PROJECT_SAVING = false
                    this.START_UPDATE_CHECKER();
                });
            }
        })

    }

    static CALL({ resource, data = {}, method = 'GET'}){
        return new Promise((resolve, reject) => {
            let headers = {}
            axios({
                method,
                data,
                headers,
                url: `${store.getState().apiBaseUrl}${resource}`,
                signal: this.REQUEST_CONTROLLER.signal
            }).then(response => {
                resolve(response)
                this.NETWORK_ERROR_COUNT = 0;
                this.NETWORK_ERROR_NOTIFICATION_THRESHHOLD = 1;
            }).catch(error => {
                this.NETWORK_ERROR_COUNT++;
                if(this.NETWORK_ERROR_COUNT === this.NETWORK_ERROR_NOTIFICATION_THRESHHOLD){
                    this.NETWORK_ERROR_NOTIFICATION_THRESHHOLD = this.NETWORK_ERROR_NOTIFICATION_THRESHHOLD * 2;
                    this.NETWORK_ERROR_COUNT = 0
                    store.dispatch({ type: CONTENT.CONNECTION_ISSUES,  payload: true})
                }
                reject();
            });
        })
    }

}
export default GEST_API;